enum EnvironmentHostName {
    LOCAL = 'localhost',
    DEV = 'dev.attributestoreadapter.gpp.gls-group.com',
    STAGE = 'stage.attributestoreadapter.gpp.gls-group.com',
    SANDBOX = 'sandbox.attributestoreadapter.gpp.gls-group.com',
    PROD = 'attributestoreadapter.gpp.gls-group.com'
}

export default EnvironmentHostName;
